import { Node, mergeAttributes, wrappingInputRule } from '@tiptap/core';
var ListItemName = 'listItem';
var TextStyleName = 'textStyle';
/**
 * Matches a bullet list to a dash or asterisk.
 */

var inputRegex = /^\s*([-+*])\s$/;
/**
 * This extension allows you to create bullet lists.
 * This requires the ListItem extension
 * @see https://tiptap.dev/api/nodes/bullet-list
 * @see https://tiptap.dev/api/nodes/list-item.
 */

var BulletList = Node.create({
  name: 'bulletList',
  addOptions: function addOptions() {
    return {
      itemTypeName: 'listItem',
      HTMLAttributes: {},
      keepMarks: false,
      keepAttributes: false
    };
  },
  group: 'block list',
  content: function content() {
    return "".concat(this.options.itemTypeName, "+");
  },
  parseHTML: function parseHTML() {
    return [{
      tag: 'ul'
    }];
  },
  renderHTML: function renderHTML(_ref) {
    var HTMLAttributes = _ref.HTMLAttributes;
    return ['ul', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
  addCommands: function addCommands() {
    var _this = this;

    return {
      toggleBulletList: function toggleBulletList() {
        return function (_ref2) {
          var commands = _ref2.commands,
              chain = _ref2.chain;

          if (_this.options.keepAttributes) {
            return chain().toggleList(_this.name, _this.options.itemTypeName, _this.options.keepMarks).updateAttributes(ListItemName, _this.editor.getAttributes(TextStyleName)).run();
          }

          return commands.toggleList(_this.name, _this.options.itemTypeName, _this.options.keepMarks);
        };
      }
    };
  },
  addKeyboardShortcuts: function addKeyboardShortcuts() {
    var _this2 = this;

    return {
      'Mod-Shift-8': function ModShift8() {
        return _this2.editor.commands.toggleBulletList();
      }
    };
  },
  addInputRules: function addInputRules() {
    var _this3 = this;

    var inputRule = wrappingInputRule({
      find: inputRegex,
      type: this.type
    });

    if (this.options.keepMarks || this.options.keepAttributes) {
      inputRule = wrappingInputRule({
        find: inputRegex,
        type: this.type,
        keepMarks: this.options.keepMarks,
        keepAttributes: this.options.keepAttributes,
        getAttributes: function getAttributes() {
          return _this3.editor.getAttributes(TextStyleName);
        },
        editor: this.editor
      });
    }

    return [inputRule];
  }
});
export { BulletList, BulletList as default, inputRegex };